export const DOCUMENT_TYPES_GET_REQUESTING = 'DOCUMENT_TYPES_GET_REQUESTING';
export const DOCUMENT_TYPES_GET_SUCCESS = 'DOCUMENT_TYPES_GET_SUCCESS';
export const DOCUMENT_TYPES_GET_ERROR = 'DOCUMENT_TYPES_GET_ERROR';